import { render, staticRenderFns } from "./AddUserToUserGroup.vue?vue&type=template&id=bbed0762"
import script from "./AddUserToUserGroup.vue?vue&type=script&lang=js"
export * from "./AddUserToUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports